import styles from './Input.module.css'
import React from 'react'

const Input = props => {
   return <input type={props.type} placeholder={props.placeholder} onChange={props.onChange} className={styles.input + ' ' + props.className} />
}

export default Input